export default __webpack_public_path__ + "static/media/bg-plataforma.4b5e15c8.svg";